const LocalStorageService = (function() {

  function _setToken(tokenObj) {
    localStorage.setItem("access_token", tokenObj.access_token);
    localStorage.setItem("refresh_token", tokenObj.refresh_token);
  }


  function _setWizardState(state) {
    if (state) localStorage.setItem("local_wizard_state", JSON.stringify(state));
    else localStorage.removeItem("local_wizard_state");
  }

  function _getWizardState() {
    let wizard_state = localStorage.getItem("local_wizard_state");
    if (wizard_state) {
      try {
        let res = JSON.parse(wizard_state)
        
        return res;
      } catch(err) {
        return { completedStep : 0, selectedStep : 1, meta : {} };
      }
    }
    return { completedStep : 0, selectedStep : 0 , meta: {} } 
  }

  function _setAvatar(avatar) {
    if (avatar) localStorage.setItem("local_avatar", avatar);
    else localStorage.removeItem("local_avatar");
  }

  function _getAvatar() {
    return localStorage.getItem("local_avatar");
  }

  function _setGravatar(avatar) {
    if (avatar) localStorage.setItem("local_gravatar", avatar);
    else localStorage.removeItem("local_gravatar");
  }

  function _getGravatar() {
    return localStorage.getItem("local_graavatar");
  }

   function _setCookie(cookie) {
    localStorage.setItem("cookie_bar", JSON.stringify({cookie : cookie}));
  }

  function _getCookie() {
    let settings = localStorage.getItem("cookie_bar");
    if (!settings) return true;
    return JSON.parse(settings).cookie;
  }

  function _setLocale(locale) {
    if (locale) localStorage.setItem("locale", locale);
    else localStorage.removeItem("locale");
  }

  function _getLocale() {
    let locale = localStorage.getItem("locale");
    if (locale) return locale;
    else return "it";
  }

  function _getAccessToken() {
    return localStorage.getItem("access_token");
  }

  function _getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }

  function _clearToken() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }

  return {
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    getAvatar: _getAvatar,
    setAvatar: _setAvatar,
    getGravatar: _getGravatar,
    setGravatar: _setGravatar,
    getLocale: _getLocale,
    setLocale: _setLocale,
    getCookie: _getCookie,
    setCookie: _setCookie,
    setWizardState : _setWizardState,
    getWizardState : _getWizardState,
  };
})();

export default LocalStorageService;
